import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import axios from "axios";

export const fetchChapterData = createAsyncThunk(
  "chapter/fetchChapterData",

  async ({ chapter_id }, { rejectWithValue, getState }) => {
    try {
      const state = getState();

      const token = state.auth.authToken;

      const tokenType = state.auth.tokenType;

      const headers = {
        Authorization: `${tokenType} ${token}`,
      };

      const url = `https://learning.motion.ac.in/motioneducation/api/v1/WebFetchNCERTPracticeChapterInfo?chapter_id=${chapter_id}`;

      const response = await axios.get(url, { headers });

      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const saveBlankProgress = createAsyncThunk(
  "chapter/saveBlankProgress",

  async (
    { chapter_id, qn_blank_id, is_correct, selected_option_index, user_id },

    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState();

      const token = state.auth.authToken;

      const tokenType = state.auth.tokenType;

      const headers = {
        Authorization: `${tokenType} ${token}`,
      };

      await axios.post(
        `https://learning.motion.ac.in/motioneducation/api/v1/storeNCERTPracticeQnBlank?user_id=${user_id}`,

        {
          chapter_id,

          qn_blank_id,

          is_correct: is_correct ? 1 : 0,

          selected_option_index,
        },

        { headers }
      );

      return {
        chapter_id,

        qn_blank_id,

        is_correct: is_correct ? 1 : 0,

        selected_option_index,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  user_progress: [],

  chapter_info: null,

  loading: false,

  error: null,

  fetchedFor: null,
};

const chapterSlice = createSlice({
  name: "chapter",

  initialState,

  reducers: {
    updateProgress: (state, action) => {
      const { qn_blank_id, is_correct, selected_option_index } = action.payload;

      const existing = state.user_progress.find(
        (p) => p.qn_blank_id === qn_blank_id
      );

      const normalizedIsCorrect = is_correct ? 1 : 0;

      if (existing) {
        existing.is_correct = normalizedIsCorrect;

        existing.selected_option_index = selected_option_index;
      } else {
        state.user_progress.push({
          qn_blank_id,

          is_correct: normalizedIsCorrect,

          selected_option_index,
        });
      }
    },

    clearChapter: (state) => {
      state.user_progress = [];

      state.chapter_info = null;

      state.loading = false;

      state.error = null;

      state.fetchedFor = null;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(fetchChapterData.pending, (state) => {
        state.loading = true;

        state.error = null;
      })

      .addCase(fetchChapterData.fulfilled, (state, action) => {
        state.loading = false;

        state.user_progress = action.payload?.user_progress || [];

        state.chapter_info = action.payload?.chapter_info || null;

        state.fetchedFor = `${action.meta.arg.chapter_id}`;
      })

      .addCase(fetchChapterData.rejected, (state, action) => {
        state.loading = false;

        state.error = action.payload;
      })

      .addCase(saveBlankProgress.fulfilled, (state, action) => {
        const { qn_blank_id, is_correct, selected_option_index } =
          action.payload;

        const existing = state.user_progress.find(
          (p) => p.qn_blank_id === qn_blank_id
        );

        if (existing) {
          existing.is_correct = is_correct;

          existing.selected_option_index = selected_option_index;
        } else {
          state.user_progress.push(action.payload);
        }
      });
  },
});

export const { updateProgress, clearChapter } = chapterSlice.actions;

export default chapterSlice.reducer;
